import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "progress"]

  connect() {
    this.setupScrollSpy()
    this.setupSmoothScroll()
    this.setupReadingProgress()
  }

  setupScrollSpy() {
    const links = this.linkTargets
    const sections = links.map(link => {
      const href = link.getAttribute('href')
      if (href && href.startsWith('#')) {
        return document.querySelector(href)
      }
      return null
    }).filter(Boolean)

    if (sections.length === 0) return

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const id = entry.target.id
        const link = this.element.querySelector(`a[href="#${id}"]`)
        
        if (entry.isIntersecting) {
          // Remove active class from all links
          links.forEach(l => l.classList.remove('active'))
          // Add active class to current link
          if (link) link.classList.add('active')
        }
      })
    }, {
      rootMargin: '-20% 0px -35% 0px',
      threshold: 0
    })

    sections.forEach(section => observer.observe(section))
  }

  setupSmoothScroll() {
    this.linkTargets.forEach(link => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href')
        if (href && href.startsWith('#')) {
          e.preventDefault()
          this.scrollToTarget(href)
        }
      })
    })
  }

  scrollToTarget(href, retryCount = 0) {
    const target = document.querySelector(href)
    if (target) {
      // Calculate header height to offset scroll position
      const header = document.querySelector('.dg-header')
      const headerHeight = header ? header.offsetHeight : 80
      const targetPosition = target.offsetTop - headerHeight - 20 // Extra 20px padding
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    } else if (retryCount < 3) {
      // Retry after a short delay if target not found (content might still be rendering)
      setTimeout(() => {
        this.scrollToTarget(href, retryCount + 1)
      }, 100)
    } else {
      console.log('Target not found after retries for href:', href)
    }
  }

  setupReadingProgress() {
    const progressBar = document.getElementById('reading-progress')
    if (!progressBar) return

    const updateProgress = () => {
      const article = document.querySelector('.dg-article')
      if (!article) return

      const articleRect = article.getBoundingClientRect()
      const articleTop = articleRect.top + window.scrollY
      const articleHeight = articleRect.height
      const windowHeight = window.innerHeight
      const scrollTop = window.scrollY

      // Calculate progress
      const start = articleTop - windowHeight
      const end = articleTop + articleHeight
      const progress = Math.max(0, Math.min(100, ((scrollTop - start) / (end - start)) * 100))

      progressBar.style.width = `${progress}%`
    }

    // Initial update
    updateProgress()

    // Update on scroll
    window.addEventListener('scroll', updateProgress, { passive: true })
  }
}